import { render, staticRenderFns } from "./CalculationResultModal.vue?vue&type=template&id=08cf3bb0"
import script from "./CalculationResultModal.vue?vue&type=script&lang=js"
export * from "./CalculationResultModal.vue?vue&type=script&lang=js"
import style0 from "./CalculationResultModal.vue?vue&type=style&index=0&id=08cf3bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports